/**
 * 公共函数
 */

/**
 * 从url获取参数
 * @export
 * @param {string} name
 * @param {string} search
 * @returns {string}
 */
export function queryURL(name, search) {
    const reg = new RegExp(`(^|&|\\?)${name}=([^&]*)(&|$)`, "i");
    const result = search.substr(1).match(reg);
    if (result !== null) {
        return decodeURI(result[2]);
    }
    return null;
}

// 时长 00:00:00
export function liveTime(millisecond) {
    const s = 1000 * 60
    const min = s * 60
    const h = Math.floor(millisecond / min)
    const min2 = Math.floor((millisecond - h * min) / s)
    const s2 = Math.floor((millisecond - h * min - min2 * s) / 1000)
    return `${formatZero(h, 2)}:${formatZero(min2, 2)}:${formatZero(s2, 2)}`
}

// 补0
export function formatZero(num, len) {
    if (String(num).length >= len) return num
    return (Array(len).join(0) + num).slice(-len)
}

// 13位时间戳转时间 2020-11-12 19:59:54
export function timestampToTimeLong(timestamp) {
    var date = new Date(timestamp)
    var Y = date.getFullYear() + '-'
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
    const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
    return Y + M + D + h + m + s
}

//分转化为元 - 正则解决精度
export const regFenToYuan = (fen) => {
    var num = fen;
    num = fen * 0.01;
    num += '';
    var reg = num.indexOf('.') > -1 ? /(\d{1,3})(?=(?:\d{3})+\.)/g : /(\d{1,3})(?=(?:\d{3})+$)/g;
    num = num.replace(reg, '$1');
    num = toDecimal2(num)
    return num
};

//元转分 - 解决精度问题 yuan:要转换的钱，单位元； digit：转换倍数
export const regYuanToFen = (yuan, digit) => {
    var m = 0,
        s1 = yuan.toString(),
        s2 = digit.toString();
    try {
        m += s1.split(".")[1].length
    } catch (e) {
        console.log(e)
    }
    try {
        m += s2.split(".")[1].length
    } catch (e) {
        console.log(e)
    }
    return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
}

//强制保留2位小数，如：2，会在2后面补上00.即2.00
export const toDecimal2 = (x) => {
    var f = parseFloat(x);
    if (isNaN(f)) {
        return false;
    }
    var f = Math.round(x * 100) / 100;
    var s = f.toString();
    var rs = s.indexOf('.');
    if (rs < 0) {
        rs = s.length;
        s += '.';
    }
    while (s.length <= rs + 2) {
        s += '0';
    }
    return s;
}

export const imgUrlTransfer = (x) =>{
    return x.replace("open.txbj.file.xintin.cn", "txsy-open-1253341261.cos.ap-beijing.myqcloud.com");
}